import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { TagService, Tag, VulnerabilitySeverity } from '../service/index';
import { toPromise } from '../utils';
import { ErrorHandler } from '../error-handler/index';
import {Label} from "../service/interface";

@Component({
    selector: 'hbr-tag-detail',
    template: `<div>
    <section class="overview-section">
        <div class="title-wrapper">
            <div class="title-block arrow-block" *ngIf="withAdmiral">
                <clr-icon class="rotate-90 arrow-back" shape="arrow" size="36" (click)="onBack()"></clr-icon>
            </div>
            <div class="title-block">
                <h2 class="custom-h2">{{repositoryId}}:{{tagDetails.name}}</h2>
            </div>
        </div>
        <div class="summary-block row">
            <div class="image-summary col-md-4 col-sm-6">
                <div class="flex-block">
                    <section class="image-detail-label">
                        <section class="detail-row">
                            <label class="detail-label">{{'TAG.AUTHOR' | translate }}</label>
                            <div class="image-details" [title]="author | translate">{{author | translate}}</div>
                        </section>
                        <section class="detail-row">
                            <label class="detail-label">{{'TAG.ARCHITECTURE' | translate }}</label>
                            <div class="image-details" [title]="tagDetails.architecture">{{tagDetails.architecture}}</div>
                        </section>
                        <section class="detail-row"> 
                            <label class="detail-label">{{'TAG.OS' | translate }}</label>
                            <div class="image-details" [title]="tagDetails.os">{{tagDetails.os}}</div>
                        </section>
                        <section class="detail-row">
                            <label class="detail-label">{{'TAG.DOCKER_VERSION' | translate }}</label>
                            <div class="image-details" [title]="tagDetails.docker_version">{{tagDetails.docker_version}}</div>
                        </section>
                        <section class="detail-row">
                            <label class="detail-label">{{'TAG.SCAN_COMPLETION_TIME' | translate }}</label>
                            <div class="image-details" [title]="scanCompletedDatetime | date">{{scanCompletedDatetime | date}}</div>
                        </section>
                    </section>
                </div>
            </div>
            <div *ngIf="withClair" class="col-md-4 col-sm-6">
                <div class="vulnerability">
                    <hbr-vulnerability-bar [repoName]="repositoryId" [tagId]="tagDetails.name" [summary]="tagDetails.scan_overview"></hbr-vulnerability-bar>
                </div>
                <div class="flex-block vulnerabilities-info">
                    <div class="second-column">
                        <div>
                            <clr-icon shape="error" size="24" class="is-error"></clr-icon> {{highCount}} {{'VULNERABILITY.SEVERITY.HIGH' | translate }}&nbsp;{{'TAG.LEVEL_VULNERABILITIES'
                            | translate }}</div>
                        <div class="second-row">
                            <clr-icon shape="exclamation-triangle" size="24" class="tip-icon-medium"></clr-icon>{{mediumCount}} {{'VULNERABILITY.SEVERITY.MEDIUM' | translate }}&nbsp;{{'TAG.LEVEL_VULNERABILITIES'
                            | translate }}</div>
                        <div>
                            <clr-icon shape="play" size="20" class="tip-icon-low rotate-90"></clr-icon>{{lowCount}} {{'VULNERABILITY.SEVERITY.LOW' | translate }}&nbsp;{{'TAG.LEVEL_VULNERABILITIES'
                            | translate }}</div>
                        <div class="second-row">
                            <clr-icon shape="help" size="18"></clr-icon>{{unknownCount}} {{'VULNERABILITY.SEVERITY.UNKNOWN' | translate }}&nbsp;{{'TAG.LEVEL_VULNERABILITIES'
                            | translate }}</div>
                    </div>
                </div>

            </div>
            <div *ngIf="!withAdmiral && tagDetails?.labels?.length">
                <div class="third-column detail-title">{{'TAG.LABELS' | translate }}</div>
                <div class="fourth-column">
                    <div *ngFor="let label of tagDetails.labels" style="margin-bottom: 2px;">
                        <hbr-label-piece [label]="label"></hbr-label-piece>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="detail-section">
        <div class="vulnerability-block">
            <hbr-vulnerabilities-grid [repositoryId]="repositoryId" [tagId]="tagId"></hbr-vulnerabilities-grid>
        </div>
        <div>
            <ng-content></ng-content>
        </div>
    </section>
</div>`,
    styles: [`@charset "UTF-8";.overview-section{padding-bottom:36px}.detail-section{background-color:#fafafa;padding-left:12px;padding-right:24px}.tag-name{font-weight:300;font-size:32px}.tag-name h2{margin-top:0}.tag-timestamp{font-weight:400;font-size:12px;margin-top:6px}.rotate-90{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.arrow-back{cursor:pointer}.arrow-block{border-right:2px solid #ccc;margin-right:6px;display:inline-flex;padding:6px 6px 6px 12px}.title-block{display:inline-block}.vulnerability-block{margin-bottom:12px}.summary-block{margin-top:24px;display:flex;flex-wrap:row wrap}.flex-block{display:inline-flex;flex-wrap:row wrap;justify-content:space-around}.vulnerabilities-info{padding-left:24px}.third-column{margin-left:36px}.vulnerability{margin-left:50px;margin-top:-12px;margin-bottom:20px}.vulnerabilities-info .second-column{text-align:left;margin-left:6px}.fourth-column{float:left;margin-left:20px}.vulnerabilities-info .second-row{margin-top:6px}.detail-title{float:left;font-weight:600;font-size:14px}.image-detail-label{margin-right:10px;text-align:left;font-weight:600}.image-detail-label .detail-row{display:flex}.image-detail-label .detail-row .detail-label{flex:0 0 150px}.image-detail-label .detail-row .image-details{width:200px;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word;white-space:nowrap}.image-detail-value{text-align:left;margin-left:6px;font-weight:500}.tip-icon-medium{color:orange}.tip-icon-low{color:#ff0}.fourth-column div,.image-detail-value div{height:24px}.second-column div{padding-left:30px}.second-column div clr-icon{margin-right:10px;margin-left:-35px}`],

    providers: []
})
export class TagDetailComponent implements OnInit {
    _highCount: number = 0;
    _mediumCount: number = 0;
    _lowCount: number = 0;
    _unknownCount: number = 0;
    labels: Label;

    @Input() tagId: string;
    @Input() repositoryId: string;
    @Input() withAdmiral: boolean;
    @Input() withClair: boolean;
    tagDetails: Tag = {
        name: "--",
        size: "--",
        author: "--",
        created: new Date(),
        architecture: "--",
        os: "--",
        docker_version: "--",
        digest: "--",
        labels: [],
    };

    @Output() backEvt: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private tagService: TagService,
        private errorHandler: ErrorHandler) { }

    ngOnInit(): void {
        if (this.repositoryId && this.tagId) {
            toPromise<Tag>(this.tagService.getTag(this.repositoryId, this.tagId))
                .then(response => {
                    this.tagDetails = response;
                    if (this.tagDetails &&
                        this.tagDetails.scan_overview &&
                        this.tagDetails.scan_overview.components &&
                        this.tagDetails.scan_overview.components.summary) {
                        this.tagDetails.scan_overview.components.summary.forEach(item => {
                            switch (item.severity) {
                                case VulnerabilitySeverity.UNKNOWN:
                                    this._unknownCount += item.count;
                                    break;
                                case VulnerabilitySeverity.LOW:
                                    this._lowCount += item.count;
                                    break;
                                case VulnerabilitySeverity.MEDIUM:
                                    this._mediumCount += item.count;
                                    break;
                                case VulnerabilitySeverity.HIGH:
                                    this._highCount += item.count;
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                })
                .catch(error => this.errorHandler.error(error));
        }
    }

    onBack(): void {
        this.backEvt.emit(this.repositoryId);
    }

    getPackageText(count: number): string {
        return count > 1 ? "VULNERABILITY.PACKAGES" : "VULNERABILITY.PACKAGE";
    }

    public get author(): string {
        return this.tagDetails && this.tagDetails.author ? this.tagDetails.author : 'TAG.ANONYMITY';
    }

    public get highCount(): number {
        return this._highCount;
    }

    public get mediumCount(): number {
        return this._mediumCount;
    }

    public get lowCount(): number {
        return this._lowCount;
    }

    public get unknownCount(): number {
        return this._unknownCount;
    }

    public get scanCompletedDatetime(): Date {
        return this.tagDetails && this.tagDetails.scan_overview ?
            this.tagDetails.scan_overview.update_time : null;
    }

    public get suffixForHigh(): string {
        return this.highCount > 1 ? "VULNERABILITY.PLURAL" : "VULNERABILITY.SINGULAR";
    }

    public get suffixForMedium(): string {
        return this.mediumCount > 1 ? "VULNERABILITY.PLURAL" : "VULNERABILITY.SINGULAR";
    }

    public get suffixForLow(): string {
        return this.lowCount > 1 ? "VULNERABILITY.PLURAL" : "VULNERABILITY.SINGULAR";
    }

    public get suffixForUnknown(): string {
        return this.unknownCount > 1 ? "VULNERABILITY.PLURAL" : "VULNERABILITY.SINGULAR";
    }
}
